import * as React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Overlay } from 'rcd-cpp-ui/ui/loader';
import { useSelector } from '../../utils/useSelector';

export const ItemExpiryHome = () => {
  const getAPI = useSelector(s => s.app?.elFn?.getAPI);
  const [results, setResults] = React.useState(null);
  const params = useParams();
  const itemId = params.itemId;
  React.useEffect(() => {
    if (getAPI) {
      const { getExpiryHome } = getAPI();
      getExpiryHome(itemId == undefined ? null : itemId).then(response => {
        setResults(response);
      });
    }
  }, []);

  if (!results) return <Overlay />;

  if (!results?.homeWorkspaceRefId && !results?.userWorkspaceId) {
    <Navigate to={`?id=${results.refId}`} replace />;
  }

  return (
    <Navigate
      to={`/w/${results?.homeWorkspaceRefId || results?.userWorkspaceId}?v=${
        results.expiryDashboardRefId
      }${!!results.refId ? `&id=${results.refId}` : ``}`}
      replace
    />
  );
};
